import { useState, useEffect } from "react";

const getWindowSize = () =>
  typeof window !== "undefined"
    ? { width: window.innerWidth, height: window.innerHeight }
    : { width: undefined, height: undefined };

const useResize = () => {
  const [windowSize, setWindowSize] = useState<any>(getWindowSize);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleResize = () => {
        setWindowSize((prev: { width?: number; height?: number }) => {
          const next = getWindowSize();
          if (prev.width === next.width && prev.height === next.height) return prev;
          return next;
        });
      };

      window.addEventListener("resize", handleResize);

      handleResize();

      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);
  return windowSize;
};

export default useResize;
